import * as React from 'react';
import classNames from 'classnames';
import { assign as _assign } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledTooltip } from 'reactstrap';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Surface.messages';
import { PlateSurfaceModel, PlateSurfaceDefaultModel } from 'franke-trough-dependencies';
import { requestAPIActions } from 'loopback-react-request';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ColourBottomSideProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
}

export interface ColourBottomSide {
  gelCoat?: boolean;
}

export class ColourBottomSidePartial extends React.Component<ColourBottomSideProps, ColourBottomSide> {
  constructor(props: ColourBottomSideProps) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
  }
  
  componentDidMount() {
    if (!this.gelCoat) {
      return;
    }

    this.setState({
      gelCoat: this.gelCoat,
    });
  }

  componentDidUpdate(prevProps: ColourBottomSideProps) {
    const {
      configuration,
    } = this.props;

    const prevConfiguration = prevProps.configuration;

    if (
      (configuration.result && prevConfiguration.result) && 
      (configuration.result.updated_at !== prevConfiguration.result.updated_at)  
    ) {
      if (!this.gelCoat) { return; }
      this.setState({
        gelCoat: this.gelCoat,
      });
    }
  }

  public render() {
    let value = false;

    if (typeof this.state.gelCoat !== 'undefined') {
      value = this.state.gelCoat;
    } else if (typeof this.gelCoat !== 'undefined' && this.gelCoat !== null) {
      value = this.gelCoat;
    } else if (this.surfaceDefaults && typeof this.surfaceDefaults.gelCoat.default !== 'undefined') {
      value = this.surfaceDefaults.gelCoat.default;
    }
    
    return (
      <div className="partial-colour-bottom-side position-relative pb-4">
        <div className="col-12">
        <label className={classNames({disabled: this.disabled})}>
            <FormattedMessage {...MESSAGES.colorBottomSideUncoated} />
            <input
              className={this.disabled ? 'disabled' : ''}
              name="gelCoat" 
              type="radio"
              value={'false'}
              checked={value === false}
              onChange={this.handleChange}
              disabled={this.disabled}
            />
            <span className="checkmark" />
          </label>
        </div>
        <div className="col-12">
          <label className={classNames({disabled: this.disabled})}>
            <FormattedMessage {...MESSAGES.colorBottomSideGelcoat} /> 
            <input
              className={this.disabled ? 'disabled' : ''}
              name="gelCoat"
              type="radio"
              value={'true'}
              checked={value === true}
              onChange={this.handleChange}
              disabled={this.disabled}
            />
            <span className="checkmark"><></></span>
          </label>
          <span className="info-icon" id="UncontrolledTooltipExample">
            <FontAwesomeIcon icon={faInfo} />
            <UncontrolledTooltip placement="right" target="UncontrolledTooltipExample">
              <strong>
                <FormattedMessage {...MESSAGES.colorBottomSideHint} /> 
              </strong>&nbsp;<FormattedMessage {...MESSAGES.colorBottomSideMessage} /> 
            </UncontrolledTooltip>
          </span>
        </div>
      </div>
    );
  }
  
  private get disabled(): boolean {
    return !isConfigurationEditable();
  }

  private dispatchConfiguration(gelCoat: boolean) {
    const {
      configuration
    } = this.props;
    
    if (!configuration || !configuration.result) { return; }

    const surface: PlateSurfaceModel = this.surface as PlateSurfaceModel;
    const data: PlateSurfaceModel = _assign({}, surface, {
      gelCoat,
    });
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${configuration.result && configuration.result.id}`,
        options: {
          method: 'PATCH',
          data: {surface: data}
        },
      },
      true,
    ));
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    if (this.disabled) {
      return;
    }
    const target = event.target as HTMLInputElement;
    let gelCoat: boolean = false;
    if (target.value === 'true') {
      gelCoat = true;
    } else if (target.value === 'false') {
      gelCoat = false;
    }
    this.setState({
      gelCoat
    });
    this.dispatchConfiguration(gelCoat);
  }
  
  private get gelCoat(): PlateSurfaceModel['gelCoat'] | null | undefined {
    return this.surface && this.surface.gelCoat;
  }
  
  private get surface(): PlateSurfaceModel| null | undefined {
    const {
      configuration,
    } = this.props;
    return configuration &&
      configuration.result &&
      configuration.result.surface;
  }

  private get surfaceDefaults(): PlateSurfaceDefaultModel | null | undefined {
    const {
      configuration,
    } = this.props;
    return configuration &&
      configuration.result && 
      configuration.result.defaults &&
      configuration.result.defaults.surface;
  }
}


export const ColourBottomSide = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration, 
}))(ColourBottomSidePartial);

export default ColourBottomSide;